import { atom } from 'recoil'

export type AuthAtomType = {
  agreements: Record<string, boolean>
  country: string
  phoneNumber?: string
  otp: string
  name: string
  familyName: string
  companyTitle: string
  email?: string
  signInPassword?: string
  password?: string
  confirmPassword?: string
  forgotPasswordCode?: string
}

export const DEFAULT_STATE = {
  agreements: {
    user: false,
    personal: false,
    commercial: false,
  },
  country: 'TR',
  phoneNumber: '',
  otp: '',
  name: '',
  companyTitle: '',
  familyName: '',
  email: '',
  signInPassword: '',
  password: '',
  confirmPassword: '',
  forgotPasswordCode: '',
}

export const authAtom = atom<AuthAtomType>({
  key: 'authState',
  default: DEFAULT_STATE,
})

export type AuthAtomTypeKeys = Readonly<
  | 'agreements'
  | 'country'
  | 'phoneNumber'
  | 'otp'
  | 'name'
  | 'familyName'
  | 'companyTitle'
  | 'email'
  | 'signInPassword'
  | 'password'
  | 'confirmPassword'
  | 'forgotPasswordCode'
>
